import { ImanageAssetPhotosReducer, Iphoto } from '../models';
import filter from 'lodash/filter';
import keyBy from 'lodash/keyBy';
import map from 'lodash/map';
import orderBy from 'lodash/orderBy';
import pickBy from 'lodash/pickBy';
import initialState, { initialPhoto } from './initialState';
import {
    ADD_NEW_PHOTO_SUCCESS,
    GET_PHOTOS_SUCCESS,
    GET_PHOTOS_FAILED,
    PUT_PHOTO_SUCCESS,
    DELETE_PHOTO_SUCCESS
} from '../actions/actionTypes';
import { combineReducers } from 'redux';
import { createSelector } from 'reselect';
import { IinitialState } from '.';
import moment from 'moment';
import { getSelectedJob } from './manageJobReducer';

export const cleanPhotoObject = (photo: any): Iphoto => {
    return {
        ...initialPhoto,
        ...pickBy(photo, (property, key) => property !== null)
    };
};

const getPhotos = (state: IinitialState) => state.photos.photos;
const getInstallParam = (state: IinitialState, prop: { installBaseID: string }) => prop.installBaseID;
export const selectPhotosForTable = createSelector(
    [getPhotos, getInstallParam, getSelectedJob],
    (allPhotos, installBaseID, selectedJob) => {
        return orderBy(
            filter(
                allPhotos,
                (p: Iphoto) =>
                    !p.isDeleted &&
                    p.installBaseID === installBaseID &&
                    p.jobID === selectedJob.id &&
                    !p.jobCommentID &&
                    !p.measurementPointID
            ),
            res => moment.utc(res?.updateDate || res?.createDate).unix(),
            'desc'
        );
    }
);

export const selectPhotosByJobComment = createSelector(
    [getPhotos, (_state: IinitialState, prop: { jobCommentID: string }) => prop.jobCommentID],
    (allPhotos, jobCommentID): Iphoto[] => {
        if (!jobCommentID) return [];
        return filter(allPhotos, (p: Iphoto) => !p.isDeleted && p.jobCommentID === jobCommentID);
    }
);

export const selectPhotosByMeasurementPoint = createSelector(
    [
        getPhotos,
        getSelectedJob,
        (_state: IinitialState, prop: { measurementPointID: string; installBaseID?: string }) => prop.measurementPointID,
        (_state: IinitialState, prop: { measurementPointID: string; installBaseID?: string }) => prop.installBaseID
    ],
    (allPhotos, selectedJob, measurementPointID, installBaseID): Iphoto[] => {
        if (!measurementPointID) return [];
        return filter(
            allPhotos,
            (p: Iphoto) =>
                !p.isDeleted &&
                p.measurementPointID === measurementPointID &&
                p.jobID === selectedJob.id &&
                (!installBaseID || p.installBaseID === installBaseID)
        );
    }
);

function photos(state: { [key: string]: Iphoto } = initialState.photos.photos, action: any): { [key: string]: Iphoto } {
    switch (action.type) {
        case GET_PHOTOS_SUCCESS: {
            const newPhotos = map(action.payload.data.result, photo => {
                return cleanPhotoObject(photo);
            });
            const keyedNewPhotos = keyBy(newPhotos, 'id');
            return { ...state, ...keyedNewPhotos };
        }
        // We can guarantee we already have the photo added, only things that can change are comments and isInReport
        case PUT_PHOTO_SUCCESS: {
            const { id, comments, isInReport } = action.payload;
            const photo = state[id];
            const updatedPhoto = { ...photo, comments, isInReport };
            return { ...state, [id]: updatedPhoto };
        }
        case ADD_NEW_PHOTO_SUCCESS: {
            const newPhoto = cleanPhotoObject(action.payload);
            return { ...state, [newPhoto.id]: newPhoto };
        }

        case DELETE_PHOTO_SUCCESS: {
            const photoToDelete = state[action.payload];
            if (!photoToDelete) {
                return state;
            }
            const deletedPhoto = { ...photoToDelete, isDeleted: true };
            return { ...state, [deletedPhoto.id]: deletedPhoto };
        }
        case GET_PHOTOS_FAILED:
            return {};
        default:
            return state;
    }
}

const manageAssetPhotos = combineReducers<ImanageAssetPhotosReducer>({
    photos
});

export default manageAssetPhotos;
